export enum EVariavelSistemaDRE {
    TotalVendas = 1,
    TotalServico = 2,
    CMV = 3,
    TotalDevolucoesVenda = 4,
}
